import type { ReactNode } from 'react'
import { Popover } from './Popover'

// Keep the help button with the label's final word when the line wraps.
export function HelpAnchor({ text, children }: { text: string; children: ReactNode }) {
  const split = text.lastIndexOf(' ') + 1
  return <>{text.slice(0, split)}<span className="help-anchor">{text.slice(split)}{'\u00a0'}{children}</span></>
}

export function HelpText({ label, text, triggerLabel = label }: { label: string; text: ReactNode; triggerLabel?: string }) {
  const rich = typeof text !== 'string'
  return <Popover ariaLabel={label} trigger={<button type="button" className="field-help" aria-label={triggerLabel}>?</button>}>
    <div className={`field-help__content${rich ? ' field-help__content--rich' : ''}`}>
      <strong>{label}</strong>{rich ? text : <p>{text}</p>}
    </div>
  </Popover>
}
